import script from "./NewProjectDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewProjectDialog.vue?vue&type=script&setup=true&lang=ts"

import "./NewProjectDialog.vue?vue&type=style&index=0&id=3bf07dd4&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf07dd4"]])

export default __exports__